/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { Carousel, Modal } from 'react-bootstrap';
import { MdArrowBackIos, MdArrowForwardIos, MdClose } from 'react-icons/md';
import AppButton from '../../../shared/components/app-button/AppButton';

function ImageGallery({ images }) {
  const count = images.length;
  const [showCarousel, setShowCarousel] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(0);

  const safeUrl = (src) => src?.url || null;

  const openCarousel = (index) => {
    setCarouselIndex(index);
    setShowCarousel(true);
  };

  const handlePrev = () => {
    setCarouselIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCarouselIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  // Inline modal — avoids inner-function-component remount blink
  const carouselModal = (
    <Modal
      show={showCarousel}
      onHide={() => setShowCarousel(false)}
      size="xl"
      centered
      className="hdp-carousel-modal"
    >
      <Modal.Header className="hdp-carousel-modal__header">
        <Modal.Title style={{ fontSize: '15px', fontWeight: 600 }}>
          {carouselIndex + 1} / {count} Photos
        </Modal.Title>
        <button
          type="button"
          className="hdp-carousel-modal__close"
          onClick={() => setShowCarousel(false)}
        >
          <MdClose />
        </button>
      </Modal.Header>
      <Modal.Body className="hdp-carousel-modal__body p-0">
        <Carousel
          activeIndex={carouselIndex}
          onSelect={(idx) => setCarouselIndex(idx)}
          interval={null}
          controls={false}
          indicators
          // prevIcon={
          //   <span
          //     className="hdp-carousel-modal__nav hdp-carousel-modal__nav--prev"
          //     onClick={(e) => e.preventDefault()}
          //   >
          //     <MdArrowBackIos />
          //   </span>
          // }
          // nextIcon={
          //   <span
          //     className="hdp-carousel-modal__nav hdp-carousel-modal__nav--next"
          //     onClick={(e) => e.preventDefault()}
          //   >
          //     <MdArrowForwardIos />
          //   </span>
          // }
        >
          {images.map((src, i) => {
            const url = safeUrl(src);
            if (!url) return null;
            return (
              <Carousel.Item key={i}>
                <div className="hdp-carousel-modal__slide">
                  <img
                    src={url}
                    alt={`Photo ${i + 1}`}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
        <button
          className="hdp-carousel-modal__nav hdp-carousel-modal__nav--prev"
          onClick={handlePrev}
        >
          <MdArrowBackIos />
        </button>

        {/* ✅ Custom Next Button */}
        <button
          className="hdp-carousel-modal__nav hdp-carousel-modal__nav--next"
          onClick={handleNext}
        >
          <MdArrowForwardIos />
        </button>
      </Modal.Body>
    </Modal>
  );

  if (count === 0) return null;

  if (count === 1) {
    const url = safeUrl(images[0]);
    if (!url) return null;
    return (
      <>
        <div className="hdp_gallery hdp_one-image">
          <img
            src={url}
            alt="Image 1"
            style={{ cursor: 'pointer' }}
            onClick={() => openCarousel(0)}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
        {carouselModal}
      </>
    );
  }

  if (count === 2) {
    return (
      <>
        <div className="hdp_gallery hdp_two-images">
          {images.map((src, i) => {
            const url = safeUrl(src);
            if (!url) return null;
            return (
              <img
                key={i}
                src={url}
                alt={`Image ${i + 1}`}
                style={{ cursor: 'pointer' }}
                onClick={() => openCarousel(i)}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            );
          })}
        </div>
        {carouselModal}
      </>
    );
  }

  // 3+ images
  return (
    <>
      <div className="hdp_gallery hdp_three-images">
        <div className="hdp_large-image">
          {safeUrl(images[0]) && (
            <img
              src={safeUrl(images[0])}
              alt="Main"
              style={{ cursor: 'pointer' }}
              onClick={() => openCarousel(0)}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          )}
        </div>
        <div className="hdp_small-images">
          {safeUrl(images[1]) && (
            <img
              src={safeUrl(images[1])}
              alt="Side 1"
              style={{ cursor: 'pointer' }}
              onClick={() => openCarousel(1)}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          )}
          <div className="position-relative">
            {count > 3 && (
              <div className="position-absolute hdp_gallery_show-more-btn">
                <AppButton
                  btnText={`+${count - 3} More Photos`}
                  variant="primary"
                  className="px-3"
                  onClick={() => openCarousel(3)}
                />
              </div>
            )}
            {safeUrl(images[2]) && (
              <img
                src={safeUrl(images[2])}
                alt="Side 2"
                style={{ cursor: 'pointer' }}
                onClick={() => openCarousel(2)}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            )}
          </div>
        </div>
      </div>

      {carouselModal}
    </>
  );
}

export default ImageGallery;
